import{b as e}from"./chunk-4H6GTEGE.mjs";import{j as o,k as r}from"./chunk-5DGXOR5D.mjs";var f=new o({locale:[e,r]});export{f as a};
